// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LightBoxPreview_wrapper__1v36o","thumbnail":"LightBoxPreview_thumbnail__hQolp","hoverImage":"LightBoxPreview_hoverImage__3FXCp","btn":"LightBoxPreview_btn__1-vCI"};